import React from "react";
import Section from "components/common/Section";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { AirtableVideoThumbnail } from "templates/Pathologies/common/AirtableVideoThumbnail";
import T from "types/index";
import { first } from "utils/lodashExtracts";

type Props = {
  videos: T.Charles.YoutubeVideoRecord[]
}
const VideoSection = ({ videos }: Props) => {
  const mainVideo: T.Charles.YoutubeVideoRecord = first(videos)
  return (
    <div className="">
      <Row>
        <Col
          className="align-self-center text-center"
          style={{ maxWidth: "635px", margin: "auto" }}
        >
          <AirtableVideoThumbnail videoRecord={mainVideo} showPlayIcon />
        </Col>
      </Row>
    </div>
  );
};

export default VideoSection;
